import { ChannelGifsOptions } from '@/app/util/channel-api'
import { giphyLocalUrl } from '@/app/util/env'
import { appendParams } from '@/util/url'

export function getChannelUrl(channelId: number | string): string {
    return `${giphyLocalUrl}/api/v4/channels/${channelId}`
}

export function getChannelGifsUrl(channelId: number | string, options: ChannelGifsOptions): string {
    return appendParams(new URL(`${giphyLocalUrl}/api/v4/channels/${channelId}/feed`), options).toString()
}
